import { MedicalHistoryControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Rajkumar Rathod
 */
export const useArchivePatientMedicineHistory = () =>
  useMutationWithLoading(
    async (param: {
      patientMedicalHistoryId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new MedicalHistoryControllerApi(
        getConfigObject()
      ).updatePatientMedicalHistoryArchiveStatus(
        param.patientMedicalHistoryId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
